const INDEX = '/'
const AUTH = '/auth'
const CREATE_ACCOUNT = '/auth/create-account'
const SIGN_IN = '/auth/sign-in'
const RESET_PASSWORD = '/auth/reset-password'
const CHECK_EMAIL = '/auth/check-email'
const ESTIMATES_PAGE = '/estimates'
const ESTIMATES_START_PAGE = '/estimates/get-started'
const ESTIMATE_CREATE = '/estimates/create'
const ESTIMATE_MY_DETAIL = '/estimates/my/:id'
const ESTIMATE_EDIT = '/estimates/edit/:id'
const ESTIMATE_VIEW = '/estimate/:id/:isNew'
const ESTIMATE_CREATED = '/estimate/created'
const PROFILE = '/profile'
const PATIENTS_LIST = '/patientsListPage'
const PATIENT_DETAIL_PAGE = '/patientDetail/:id'
const CPT4_LIST = '/cpt4ListPage'
const MOST_ACTIVE_CPT4_LIST = '/mostActiveCpt4ListPage'
// const CPT4_DETAIL_PAGE = '/cpt4Detail/:id'
const ESTIMATE_CREATION_BY_EMAIL = '/EstimateCreationByEmail'
const CMS_REPORT = '/price-transparency'

export default {
  INDEX,
  AUTH,
  CREATE_ACCOUNT,
  SIGN_IN,
  RESET_PASSWORD,
  CHECK_EMAIL,
  ESTIMATES_PAGE,
  ESTIMATES_START_PAGE,
  ESTIMATE_CREATE,
  ESTIMATE_CREATED,
  ESTIMATE_VIEW,
  ESTIMATE_MY_DETAIL,
  ESTIMATE_EDIT,
  PROFILE,
  PATIENTS_LIST,
  PATIENT_DETAIL_PAGE,
  CPT4_LIST,
  MOST_ACTIVE_CPT4_LIST,
  ESTIMATE_CREATION_BY_EMAIL,
  CMS_REPORT
}
